import { render, staticRenderFns } from "./taobaoActivity.vue?vue&type=template&id=49f1a3ba&scoped=true&"
import script from "./taobaoActivity.vue?vue&type=script&lang=js&"
export * from "./taobaoActivity.vue?vue&type=script&lang=js&"
import style0 from "./taobaoActivity.vue?vue&type=style&index=0&id=49f1a3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f1a3ba",
  null
  
)

export default component.exports